import { render } from "./AssamSidebarTabs.vue?vue&type=template&id=2d5dd9db"
import script from "./AssamSidebarTabs.vue?vue&type=script&lang=js"
export * from "./AssamSidebarTabs.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__